package modysy.model

/** Models a static, predefined sized, rectangular obstacle game object with an image. */
class Obstacle()
    extends FixedShapeGameObject(
      new RigidBody(
        Transform.identity,
        Velocity.zero,
        Material(Double.PositiveInfinity, 1),
        Box(100, 100)
      ),
      "rgb(172,163,78)"
    ) {
  private val BarWidth = 80
  private val BarHeight = 20
  private val LifetimeBarColor = "rgb(0,255,0)"
  private val HealthBarColor = "rgb(255,0,0)"

  override def render(ctx: Ctx2D): Unit = {
    super.render(ctx)

    val drawBar = (percentage: Double, offsetY: Int, color: String) => {
      ctx.fillStyle = color
      ctx.fillRect(
        body.pose.translation.x - BarWidth / 2,
        body.pose.translation.y - BarHeight / 2 + offsetY,
        BarWidth * percentage,
        BarHeight
      )
    }

  }
}



// WEBPACK FOOTER //
// /home/gitlab-runner/builds/2d4fb5cd/0/mtv-pr-2018/modysy-product/src/main/scala/modysy/model/Obstacle.scala